import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/personallnfo.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    userinfo:{}
  },
  mutations:{
    editUserinfo(state,data){
      state.userinfo = data
    }
  },
  actions:{
    async getUserinfo({state,commit}){
      const res = await api.getPersonInfo();
      if (res.data.code === 0) {
        commit('editUserinfo',res.data.data)
      }else{
        this.$message.error(res.data.msg)
      }
    }
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js